import { render, staticRenderFns } from "./goods-vip-forever2022.vue?vue&type=template&id=289d7e55&scoped=true"
import script from "./goods-vip-forever2022.vue?vue&type=script&lang=js"
export * from "./goods-vip-forever2022.vue?vue&type=script&lang=js"
import style0 from "./goods-vip-forever2022.vue?vue&type=style&index=0&id=289d7e55&prod&scoped=true&lang=less"
import style1 from "./goods-vip-forever2022.vue?vue&type=style&index=1&id=289d7e55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "289d7e55",
  null
  
)

export default component.exports